import { head } from 'lodash';

export const generateDTSCommunicationTransactions = (
  successfulTransactions
) => {
  //Should always have one transaction record for DTS
  if (successfulTransactions.length === 1) {
    //Get the first element in successful transactions
    const transaction = head(successfulTransactions);
    if (transaction && transaction.transactionRecords) {
      return transaction.transactionRecords.map((record) => {
        return {
          ...transaction,
          '@Type': 'Transaction',
          transactionRecord: record,
          transactionRecords: [{ ...record }],
          confirmationNumber: transaction.confirmationNumber
            ? transaction.confirmationNumber
            : '0',
        };
      });
    }
  }
};
